import LoadingCard from '@/app/common/components/LoadingCard'
import { RefreshFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { AppDispatch } from '@/storage/store'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { IdentitySuccessVerified } from './IdentitySuccessVerified'
import VerificationErrorMessage from './VerificationErrorMessage'
import { static_errors } from '@/app/common/constants'
import useVerifyIdentity from '@/queries/identity_verification/useVerifyIdentity'
import { useEffect, useRef } from 'react'

interface Props {
  token: string
  programId: number
}

function SubmitIdentity(props: Props) {
  const { t: translate } = useTranslation()
  const { token, programId } = props
  const dispatch = useDispatch<AppDispatch>()

  const { data, isLoading, isError, error } = useVerifyIdentity(token, programId);
  const didCall = useRef(false)

  useEffect(() => {
    if (data && !didCall.current) {
      dispatch(RefreshFamilyApplication(programId))
      didCall.current = true
    }
  }, [data])

  if (isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <LoadingCard isLoading={true}>{translate('loading')}</LoadingCard>
      </div>
    )
  }

  if (isError) {
    const isInvalidErrorMessage = error?.message.includes(
      'Cannot assign null to property'
    )
    return (
      <VerificationErrorMessage
        errorMessage={
          isInvalidErrorMessage
            ? static_errors.unexpected_contact_support
            : error.message
        }
      />
    )
  }

  if (!isLoading && !data && !error) {
    return null
  }

  return (
    <div className="h-full flex items-center justify-center">
      <IdentitySuccessVerified />
    </div>
  )
}

export default SubmitIdentity
